var _rect, _rect2, _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductivityimg18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 39.5,
    fill: "url(#paint0_linear_852_1623)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 39.5,
    stroke: "url(#paint1_linear_852_1623)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.0003 20H24.9997C22.2434 20.0062 20.0096 22.2401 20 25V55C20 57.75 22.2495 60 24.9997 60H55.0003C57.7505 60 60 57.75 60 55V25C60 22.25 57.7505 20 55.0003 20Z",
    fill: "#A6A6C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4789 38.9462C29.178 38.5375 44.1957 29.7987 44.539 29.5962C44.8823 29.3962 44.9011 28.7812 44.5141 28.5587C44.1296 28.3375 43.3993 27.9175 43.1284 27.7562C42.7416 27.5432 42.2715 27.5488 41.89 27.7712C41.6978 27.8837 28.8659 35.3462 28.4377 35.5912C27.9221 35.8862 27.2892 35.8912 26.7774 35.5912L20 31.6087V34.9937C21.6478 35.9662 25.7512 38.3812 26.7449 38.95C27.3379 39.2875 27.9059 39.28 28.4801 38.9462",
    fill: "#F2F2F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4789 45.3463C29.178 44.9375 44.1957 36.1988 44.539 35.9963C44.8823 35.7963 44.9011 35.1813 44.5141 34.9588C44.1296 34.7375 43.3993 34.3175 43.1284 34.1563C42.7416 33.9432 42.2715 33.9489 41.89 34.1713C41.6978 34.2838 28.8659 41.7463 28.4377 41.9913C27.9221 42.2863 27.2892 42.2913 26.7774 41.9913L20 38.0088V41.3938C21.6478 42.3663 25.7512 44.7813 26.7449 45.35C27.3379 45.6875 27.9059 45.68 28.4801 45.3463",
    fill: "#F2F2F7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4789 52.1463C29.178 51.7376 44.1957 42.9988 44.539 42.7963C44.8823 42.5963 44.9011 41.9813 44.5141 41.7588C44.1296 41.5376 43.3993 41.1176 43.1284 40.9563C42.7416 40.7432 42.2715 40.7489 41.89 40.9713C41.6978 41.0838 28.8659 48.5463 28.4377 48.7913C27.9221 49.0863 27.2892 49.0913 26.7774 48.7913L20 44.8088V48.1938C21.6478 49.1663 25.7512 51.5813 26.7449 52.1501C27.3379 52.4876 27.9059 52.4801 28.4801 52.1463",
    fill: "#F2F2F7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_852_1623",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05050F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D8DB9",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_852_1623",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8DB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27273F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductivityimg18);
export default __webpack_public_path__ + "static/media/productivityimg18.ca7b6173bdedacb3c857aa49b1fd13d6.svg";
export { ForwardRef as ReactComponent };